<template>
  <component :is="layoutComponent" v-bind="{ ...sourceProperties }" />
</template>

<script setup>
import Boxed from './layouts/Boxed.vue';
import Carousel from './layouts/Carousel.vue';
import InContent from './layouts/InContent.vue';

const props = defineProps({
  heading: {
    type: String,
    default: null,
  },
  testimonialLayout: {
    type: String,
    default: 'inContent',
  },
  backgroundBlack: {
    type: Boolean,
    default: false,
  },
  testimonials: {
    type: Array,
    default: () => [],
  },

  useShopifyData: {
    type: Boolean,
    default: false,
  },

  product: {
    type: Object,
    default: null,
  },
});

const layoutComponent = computed(() => {
  switch (props.testimonialLayout) {
    case 'boxed':
      return Boxed;
    case 'carousel':
      return Carousel;
    case 'inContent':
      return InContent;
    default:
      return Boxed; // Fallback to Boxed if no match
  }
});

const sourceProperties = computed(() => {
  if (props.useShopifyData && props.product?.testimonial?.length) {
    const productTestimonial = props.product.testimonial[0];

    return {
      testimonials: [
        {
          body: productTestimonial.description || '',
          authorImage: productTestimonial.image
            ? [
                {
                  url: productTestimonial.image.fullpath || null,
                  title: productTestimonial.image.filename || null,
                },
              ]
            : [],
        },
      ],
    };
  } else {
    return {
      heading: props.heading,
      backgroundBlack: props.backgroundBlack,
      testimonials: props.testimonials,
    };
  }
});
</script>
